import { createRouter, createWebHistory } from 'vue-router';
import WorkspaceView from '../views/WorkspaceView.vue';
import MigrationView from '../views/MigrationView.vue';
import Phase17View from '../views/Phase17View.vue';
import Phase19View from '../views/Phase19View.vue';
import Phase20View from '../views/Phase20View.vue';
import Phase21View from '../views/Phase21View.vue';
import Phase22View from '../views/Phase22View.vue';
import Phase24View from '../views/Phase24View.vue';
import Phase25View from '../views/Phase25View.vue';
import Phase26View from '../views/Phase26View.vue';
import Phase27View from '../views/Phase27View.vue';
import Phase28View from '../views/Phase28View.vue';
import Phase29View from '../views/Phase29View.vue';
import Phase30View from '../views/Phase30View.vue';
import Phase31View from '../views/Phase31View.vue';
import Phase32View from '../views/Phase32View.vue';
import Phase33View from '../views/Phase33View.vue';
import Phase36View from '../views/Phase36View.vue';
import Phase38View from '../views/Phase38View.vue';
import Phase39View from '../views/Phase39View.vue';
import Phase40View from '../views/Phase40View.vue';
import NotificationsView from '../views/NotificationsView.vue';
import AdminView from '../views/AdminView.vue';
import AuthView from '../views/AuthView.vue';
import ProfileView from '../views/ProfileView.vue';
import { authService } from '../services/auth';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'workspace', component: WorkspaceView },
    { path: '/login', name: 'login', component: AuthView, meta: { authMode: 'login' } },
    { path: '/registro', name: 'register', component: AuthView, meta: { authMode: 'register' } },
    { path: '/recuperar', name: 'recovery', component: AuthView, meta: { authMode: 'recovery' } },
    { path: '/restablecer', name: 'reset', component: AuthView, meta: { authMode: 'reset' } },
    { path: '/perfil', name: 'profile', component: ProfileView, meta: { requiresAuth: true } },
    { path: '/fase-16', name: 'phase16', component: MigrationView },
    { path: '/fase-17', name: 'phase17', component: Phase17View },
    { path: '/fase-19', name: 'phase19', component: Phase19View },
    { path: '/fase-20', name: 'phase20', component: Phase20View },
    { path: '/fase-21', name: 'phase21', component: Phase21View },
    { path: '/fase-22', name: 'phase22', component: Phase22View },
    { path: '/fase-24', name: 'phase24', component: Phase24View },
    { path: '/fase-25', name: 'phase25', component: Phase25View },
    { path: '/fase-26', name: 'phase26', component: Phase26View },
    { path: '/fase-27', name: 'phase27', component: Phase27View },
    { path: '/fase-28', name: 'phase28', component: Phase28View },
    { path: '/fase-29', name: 'phase29', component: Phase29View },
    { path: '/fase-30', name: 'phase30', component: Phase30View },
    { path: '/fase-31', name: 'phase31', component: Phase31View },
    { path: '/fase-32', name: 'phase32', component: Phase32View, meta: { requiresAuth: true } },
    { path: '/fase-33', name: 'phase33', component: Phase33View, meta: { requiresAuth: true } },
    { path: '/fase-36', name: 'phase36', component: Phase36View, meta: { requiresAuth: true } },
    { path: '/fase-38', name: 'phase38', component: Phase38View, meta: { requiresAuth: true } },
    { path: '/fase-39', name: 'phase39', component: Phase39View, meta: { requiresAuth: true } },
    { path: '/fase-40', name: 'phase40', component: Phase40View, meta: { requiresAuth: true } }
    ,{ path: '/notificaciones', name: 'notifications', component: NotificationsView, meta: { requiresAuth: true } }
    ,{ path: '/admin', name: 'admin', component: AdminView, meta: { requiresAuth: true } }
  ],
  scrollBehavior: () => ({ left: 0, top: 0 })
});

router.beforeEach(async (to) => {
  const mode = String(to.meta.authMode || '');
  const state = authService.state();
  if (!state.authenticated && mode === '') {
    await authService.bootstrap();
  }
  const authenticated = authService.state().authenticated;
  if (to.meta.requiresAuth && !authenticated) {
    return { path: '/login', query: { redirect: to.fullPath } };
  }
  const hasInvitation = ['invitacion', 'invitation'].some((key) => typeof to.query[key] === 'string' && String(to.query[key]).trim().length > 0);
  if (['login', 'register'].includes(mode) && authenticated && !hasInvitation) return { path: '/' };
  return true;
});
